import { useMutation, useQueryClient } from "@tanstack/react-query"
import axios from "axios"
import { gmailIntegrationsQuery } from "modules/settings/lib/gmail/gmailIntegrationsQuery"

export function useDeleteGmailIntegrationMutation() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async ({ id }: { id: string }) => {
      await axios.delete(`/integrations/gmail/${id}`)
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: gmailIntegrationsQuery().queryKey })
    },
  })
}
